import React, {Component} from 'react';

import * as SimplyBookService from '../../services/simplyBookService';

class ContactForm extends Component {
    constructor(props){
        super(props);
        this.state = {
            submittingPost: false
        }
    }

    handleFormPost(event){
        event.preventDefault();

        this.setState({
            submittingPost: true,
            submittedPost: false
        });

        let message = {
            firstName: this.refs.firstName.value,
            lastName: this.refs.lastName.value,
            emailAddress: this.refs.emailAddress.value,
            telephoneNumber: this.refs.telephoneNumber.value,
            message: this.refs.message.value,
        }

        SimplyBookService.submitMessage(message)
            .then(() => {
                this.setState({
                    submittingPost: false,
                    submittedPost: true
                });

                // Clear fields
                this.refs.firstName.value = '';
                this.refs.lastName.value = '';
                this.refs.emailAddress.value = '';
                this.refs.telephoneNumber.value = '';
                this.refs.message.value = '';
            }).catch(() => {
            this.setState({
                submittingPost: false,
                submittedPost: false
            });
        });
    }

    render(){
        return (
            <form onSubmit={this.handleFormPost.bind(this)}>
                <div className="field">
                    <div className="field-body">
                        <div className="field">
                            <label className="label">Voornaam</label>
                            <p className="control">
                                <input className="input" type="text" placeholder="" ref="firstName" required />
                            </p>
                        </div>
                        <div className="field">
                            <label className="label">Achternaam</label>
                            <p className="control">
                                <input className="input " type="text" ref="lastName" required />
                            </p>
                        </div>
                    </div>
                </div>
                <div className="field">
                    <div className="field-body">
                        <div className="field">
                            <label className="label">E-mail adres</label>
                            <p className="control">
                                <input className="input" type="text" placeholder="" ref="emailAddress" required />
                            </p>
                        </div>
                        <div className="field">
                            <label className="label">Telefoonnummer</label>
                            <p className="control">
                                <input className="input " type="text" ref="telephoneNumber" required />
                            </p>
                        </div>
                    </div>
                </div>
                <div className="field">
                    <label className="label">Stel je vraag, waarmee kunnen we je helpen?</label>
                    <div className="control">
                        <textarea className="textarea is-primary" required type="text" ref="message" placeholder="" />
                    </div>
                </div>
                {
                    this.state.submittedPost && <div>
                        <strong>Bedankt! Uw bericht is succesvol verzonden!</strong>
                    </div>

                }
                <button type="submit" className={`button is-primary  ${this.state.submittingPost ? 'is-loading' : ''}`}>
                    Verstuur bericht
                </button>
            </form>
        )
    }
}

export default ContactForm;


// WEBPACK FOOTER //
// ./src/components/contactForm/index.js